import {Injectable} from '@angular/core';
import {Model} from '../../app.model';
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {OrderService} from "../../order/order.service";
import {SaleOrder} from '../../buy/buy.model';
import {TariffFlatOffer} from '../../tariff/tariff.model';

@Injectable()
export class WorkflowPartnerService {

  private readonly url = 'services/workflow/partner';

  constructor(private m: Model, private http: HttpClient, private saleOrderService: OrderService) {
  }

  // Some methods map contactId to partnerId, because the endpoints expect a partnerId
  // This is because of odoo-wording but we might change this in the future

  public oneApplianceCuChange(applianceId: string, cu: number, contactId: string) {
    return this.http.post<any>(`${this.url}/one/appliance/${applianceId}/cu/change`, {
      cu,
      customer_contact_id: contactId
    }).pipe(map(r => this.saleOrderService.prepareSaleOrder(r)));
  }

  public oneApplianceSlaChange(applianceId: string, sla: string, contactId: string) {
    return this.http.post<any>(`${this.url}/one/appliance/${applianceId}/sla/change`, {
      sla,
      customer_contact_id: contactId
    }).pipe(map(r => this.saleOrderService.prepareSaleOrder(r)));
  }

  public oneTrialCreateOrder(data: { instance_name: string, customer_contact_id: string, acquire_phone_number?: string }) {
    return this.http.post<any>(`${this.url}/one-trial/appliance/create`, data)
      .pipe(map(r => this.saleOrderService.prepareSaleOrder(r)));
  }

  public oneTrialAddPhonenumber(applianceId: string) {
    return this.http.post<any>(`${this.url}/one-trial/appliance/${applianceId}/add-number`, {});
  }

  public oneApplianceAddPremium(applianceId: string, contactId: string) {
    return this.http.post<any>(`${this.url}/one/appliance/${applianceId}/premium/add`, {partner_id: contactId}).pipe(map(r => this.saleOrderService.prepareSaleOrder(r)));
  }

  public oneApplianceDowngradePremium(applianceId: string, contactId: string) {
    return this.http.post<any>(`${this.url}/one/appliance/${applianceId}/premium/cancel`, {partner_id: contactId}).pipe(map(r => this.saleOrderService.prepareSaleOrder(r)));
  }

  public oneApplianceCancelPremium(saleOrder: string) {
    return this.http.post<any>(`services/subscriptions/order/${saleOrder}/cancel`, {});
  }

  public createTariffOffer(tariffFlatOffer: TariffFlatOffer, appliance_id: string) {
    return this.http.post<SaleOrder>(`${this.url}/one/appliance/${appliance_id}/flat/change`, tariffFlatOffer).pipe(map(r => this.saleOrderService.prepareSaleOrder(r)));
  }

  public oneApplianceCancelTariffOrder(saleOrder: string) {
    return this.http.post<any>(`services/subscriptions/order/${saleOrder}/cancel`, {});
  }

  public oneApplianceCreateCancelPhonenumberOrder(applianceId: string, blockId: number, contactId: string) {
    return this.http.post<any>(`${this.url}/one/appliance/${applianceId}/block/cancel`, {partner_id: contactId, block_id: blockId}).pipe(map(r => this.saleOrderService.prepareSaleOrder(r)));
  }
}
